module.exports = __webpack_public_path__ + "img/pic_261535_2.491d39bc.jpg";